import useMarketTrade from './useMarketTrade';
import useTradeEstimate from './useTradeEstimate';
import useGetTokensByNetwork from './useGetTokensByNetwork';
// import useElrondSwap from './useElrondSwap';
// import useGetElrondEstimate from './useGetElrondEstimate';
// import useGetElrondTokens from './useGetElrondTokens';
import useGetWalletBalances from './useGetWalletBalances';
import useDebounce from './useDebounce';
import useElrondTrade from './useElrondTrade';
import useGetFeaturedTokensByNetwork from './useGetFeaturedTokensByNetwork';
import useLimitNativeToken from './useLimitNativeToken';
import useTonEstimate from './useTonEstimate';
import useTonTrade from './useTonTrade';

export enum Direction {
  BaseQuote = 0,
  QuoteBase = 1,
}

export const PS_API_URL = 'https://apiv5.paraswap.io';

export {
  useMarketTrade,
  useTradeEstimate,
  useGetTokensByNetwork,
  // useElrondSwap,
  // useGetElrondEstimate,
  // useGetElrondTokens,
  useGetWalletBalances,
  useDebounce,
  useElrondTrade,
  useGetFeaturedTokensByNetwork,
  useLimitNativeToken,
  useTonEstimate,
  useTonTrade,
};
